/* eslint-disable complexity */
import {
    DANCE_STYLES,
    KEYS_OPTIONS_LABLE,
    MEDIA_TYPES,
    UPLOAD_REQUEST,
} from 'constants/dance'
import toast from 'react-hot-toast'
import ReactPlayer from 'react-player'
import moment from 'moment'

export const toastRespones = async (action, onSuccess) => {
    toast.promise(action, {
        loading: 'Loading',
        success: (response) => {
            const {data} = response
            onSuccess?.(data)
            return 'success'
        },
        error: (error) => {
            return `This just happened: ${error.message.toString()}}`
        },
    })
}

export const proccessAudioForUpload = (attachedFile) => {
    const formData = new FormData()
    const {0: newFile, length} = attachedFile
    if (length === 1) {
        formData.append(newFile.name, newFile)
    }
    return formData
}

export const proccessFilesForUpload = (attachedFile, isAudio) => {
    const formData = new FormData()
    if (isAudio && attachedFile) {
        formData.name = attachedFile.name
        formData.files = {0: attachedFile}
    } else if (attachedFile) {
        formData.append(attachedFile.name, attachedFile)
    }
    return formData
}

export const validateUpload = (value) => {
    if (typeof value === 'string') {
        return ReactPlayer.canPlay(value)
    }

    const newFile = value?.[0]

    if (newFile) {
        if (newFile?.type === 'audio/mpeg') {
            return true
        }
    }

    return false
}

export const formatName = (str, defaultValue) => {
    if (!str) {
        return ''
    }
    return str.split(',').map((name, i, row) => {
        name = name?.trim()
        const firstLetter = name?.charAt(0)
        const lowerCaseName = name?.toLowerCase()
        const editName = firstLetter + lowerCaseName?.slice(1)

        if (!editName) {
            return defaultValue
        }
        if (i + 1 === row.length) {
            return editName
        }
        return editName + ' '
    })
}

export const isStyleUnknown = (style) =>
    !Object.keys(DANCE_STYLES).includes(style)

export const translateDanceStyle = (dance, t) => {
    if (!dance) {
        return null
    }
    let styleLabel

    if (!isStyleUnknown(dance?.style)) {
        styleLabel = `${t('styles.' + DANCE_STYLES[dance.style])}`
    } else {
        styleLabel = dance.style
    }

    return `${t('danceStyle')} ${styleLabel}`
}

export const getSortedMediaList = (mediaList) => {
    const confirmedMedia = mediaList.filter((media) => media.isConfirmed)
    const favoriteMedia = confirmedMedia.filter(
        (media) => media.isFavorite === true
    )
    const filterMedia = confirmedMedia.filter((media) => !media.isFavorite)
    if (favoriteMedia) {
        return [...favoriteMedia, ...filterMedia]
    }
    return mediaList
}

export const getMediasWithPendingRequest = (mediaList) => {
    if (!mediaList?.length > 0) {
        return []
    }
    return mediaList.filter((media) => !media.isConfirmed)
}

export const getDancesWithPendingMedias = (dances, doCount) => {
    if (!dances?.length > 0) {
        return []
    }

    return dances.filter(
        (dance) => getMediasWithPendingRequest(dance.media)?.length > 0
    )
}

export const countPendingMedias = (dance) => {
    return dance.media.reduce(
        (counter, media) => counter + !media.isConfirmed,
        0
    )
}

export const getPendingMediasCount = (dances) => {
    let counter = 0
    // dances?.map((dance) => (counter += countPendingMedias(dance)))
    return counter
}

export const extractTableData = (data, visibleKeys) => {
    let tableData = data
    let tableHeaders = []

    if (data?.length > 0) {
        tableHeaders = Object.keys(data[0])
    }

    if (visibleKeys) {
        tableData = data.map((row) => {
            return visibleKeys.reduce((acc, key) => {
                if (row[key]) {
                    acc[key] = row[key]
                }
                return acc
            }, {})
        })
    }
    return {tableHeaders, tableData}
}

export const formatAutocompleteOption = (data, field) =>
    data[KEYS_OPTIONS_LABLE[field]]

export const formatMediaNumbers = (isSong, media, t) => {
    if (isSong) {
        return `${t('numOfDownloads')} ${media?.numOfDownloads}`
    }
    return ` ${t('numOfViews')} ${media?.numOfViews}`
}

export const zoomPercent = (value) => `${Math.round(value * 100)}%`

export const getFormattedDate = (date, t) =>
    t('uploadDate') + moment(date).format('DD/MM/YYYY')

export const getCreatorsText = (creators) =>
    creators
        ?.map((creator) => `${creator?.firstName} ${creator?.lastName}`)
        ?.join(', ')

export const formatSearchResult = (result) => {
    const {creators, name, style, performer, song, creationDate} = result || {}

    const year = new Date(creationDate).getFullYear()

    return {
        creators: getCreatorsText(creators),
        name,
        style,
        performer,
        lyricist: song[0]?.lyricist,
        composer: song[0]?.composer,
        creationDate: year,
    }
}

const findMediaType = (type, medias) =>
    medias.find(({mediaType}) => mediaType === type)

export const getDanceMediasIcons = (danceMedias) => {
    const isSong = findMediaType(MEDIA_TYPES.song, danceMedias)
    const isVideo = findMediaType(MEDIA_TYPES.video, danceMedias)

    return {isSong, isVideo}
}

export const getDoDisplayButtons = (user, isChoreogapher, type) => {
    return {
        displayDeleteButton: getShouldDisplayPin(user, isChoreogapher, type),
        displayPinButton: getShouldDisplayDelete(isChoreogapher, type),
    }
}

const getShouldDisplayPin = (user, isChoreogapher, type) =>
    (isChoreogapher || user?.role === 'admin') && type === 'video'

const getShouldDisplayDelete = (isChoreogapher, type) =>
    isChoreogapher && Object.keys(MEDIA_TYPES).includes(type)

export const getRequestTitle = (mediaType, t) => {
    const translatedMediaType = t(mediaType)
    return t(UPLOAD_REQUEST, {
        mediaType: translatedMediaType,
    })
}

export const isDanceCreator = (user, dance) =>
    dance?.creators?.find(({email}) => email === user?.email)

export const createAdvancedSearchDancesQueryString = (params) => {
    const {name = '', choreographer, artist, styles = []} = params
    const choreographerId = choreographer?._id || null
    const artistId = artist?._id || null
    const styleValues = styles.map((style) => style.value).join(',')
    const queryString = new URLSearchParams({
        ...(name && {name}),
        ...(choreographerId && {choreographerId}),
        ...(artistId && {artistId}),
        ...(styles.length && {styles: styleValues}),
    }).toString()

    return queryString
}
